/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class IncidentsRoute extends Route {
  queryParams = {
    dateFrom: {
      refreshModel: true,
    },
    dateTo: {
      refreshModel: true,
    },
  };

  // Services
  @service
  session;

  @service
  store;

  // State
  // dateFrom provides a setup binding for filtering to today's date when a
  // query param is not provided on the route.
  dateFrom = moment().format('YYYY-MM-DD');

  // dateTo provides a setup binding for filtering to today's date when a
  // query param is not provided on the route.
  dateTo = moment().format('YYYY-MM-DD');

  startOfYear = moment().startOf('year').format('YYYY-MM-DD');
  endOfYear = moment().endOf('year').format('YYYY-MM-DD');

  resetController(controller, isExiting) {
    if (isExiting) {
      // This hook is called when exiting the route in order to reset the filters
      // Prevents issues with empty tables and no filter options
      controller.set('filters', []);
    }
  }

  model(params) {
    let dateFrom =
      moment(params.dateFrom).unix() || moment(this.dateFrom).unix();
    let dateTo = moment(params.dateTo).unix() || moment(this.dateTo).unix();

    return hash({
      behaviourPage: this.store
        .query('posts/page', {
          isBehaviour: true,
        })
        .then((pages) => {
          return pages[0];
        }),
      behaviourIncidents: this.store.query('attendance/behaviour-incident', {
        schoolId: this.get('session.activeSchool'),
        dateFrom,
        dateTo,
      }),
      expulsions: this.store.query('attendance/expulsion', {
        schoolId: this.get('session.activeSchool'),
        dateFrom: this.startOfYear,
        dateTo: this.endOfYear,
      }),
      suspensions: this.store.query('attendance/suspension', {
        schoolId: this.get('session.activeSchool'),
        dateFrom: this.startOfYear,
        dateTo: this.endOfYear,
      }),
      // Resolved to a plain array: the {{reverse}} template helper calls
      // A() on it, which throws on ember-data's live-array proxy.
      terms: this.store.findAll('term').then((terms) => terms.slice()),
      learners: this.store.query('person', {
        type: PersonType.LEARNER,
        includeFormer: true,
      }),
    });
  }
}
